import { THUMBNAIL_MAX_WIDTH, THUMBNAIL_QUALITY, THUMBNAIL_RATIO } from 'constants/params';

export interface PlayerFrame {
  blob: Blob;
  dataUri: string;
}

export const captureFrame = (
  elem: HTMLVideoElement | HTMLImageElement,
  srcWidth: number,
  srcHeight: number
): PlayerFrame => {
  const maxWidth = THUMBNAIL_MAX_WIDTH;
  const maxHeight = THUMBNAIL_MAX_WIDTH / THUMBNAIL_RATIO;
  const ratio = THUMBNAIL_RATIO;

  const srcRatio = srcWidth / srcHeight;

  let width = 0;
  let height = 0;
  let dWidth = 0;
  let dHeight = 0;
  let dx = 0;
  let dy = 0;

  if (srcRatio > ratio) {
    height = maxHeight < srcHeight ? maxHeight : srcHeight;
    width = height * ratio;
    dHeight = height;
    dWidth = height * srcRatio;
    dx = (dWidth - width) / 2;
  } else {
    width = maxWidth < srcWidth ? maxWidth : srcWidth;
    height = width / ratio;
    dWidth = width;
    dHeight = width / srcRatio;
    dy = (dHeight - height) / 2;
  }

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  canvas.getContext('2d')!.drawImage(elem, -dx, -dy, dWidth, dHeight);

  const dataUri = canvas.toDataURL('image/webp', THUMBNAIL_QUALITY);
  const data = dataUri.split(',')[1];
  const mimeType = dataUri.split(';')[0].slice(5);

  const bytes = window.atob(data);
  const buf = new ArrayBuffer(bytes.length);
  const arr = new Uint8Array(buf);
  for (let i = 0; i < bytes.length; i++) {
    arr[i] = bytes.charCodeAt(i);
  }

  return { blob: new Blob([arr], { type: mimeType }), dataUri: dataUri };
};
